<template>
  <div class="main">
    <div class="top">
      <div class="order-ok">
        <img :src="radio === '1'?wx:alipay"/>
      </div>
      <div class="tips" v-if="radio == 1" style="color:#04BE02">支付成功</div>
      <div class="tips" v-else style="color:#1678FF">支付成功</div>
      <div class="money" >￥ {{payInfo.payMoney}} 元</div>
      <div class="money2" >商家收款{{payInfo.payMoney}}元</div>
    </div>
    <div class="collection-info">
       <!-- <van-field label="收款方:" value="{{collection}}" border="{{ false }}"  readonly  input-align='right'/>
      <van-field label="交易时间" value="{{time}}" border="{{ false }}" readonly  input-align='right'/> -->
      <div class="plate">
        <div class="plate-left" >收款方:</div>
        <div class="righ-class" style="margin-left:10px">济南堤口集团有限责任公司</div>
      </div>
      <div class="plate">
        <div class="plate-left" >交易时间:</div>
        <div class="righ-class" style="margin-left:10px">{{time}}</div>
      </div>
    </div>
    <div style="margin-top:30px;font-size:22px;color:#969594;text-align: center;">若不抬杆请与市场管理员联系</div>
    <div style="margin-top:50px;font-size:22px;color:#007E5C;text-align: center;">堤口果品批发市场欢迎您再次光临！</div>

  </div>
</template>

<script>
// import Vue from 'vue';
// import request from "@/utils/request";
import { get } from '../utils/request'
import axios from 'axios'
export default {
  name: 'order',
  data () {
    return {
      radio: '1', // 支付宝或微信
      color:'',  //字体颜色
      time: '', // 交易时间
      wx: require('../assets/wx-ok.png'),
      alipay: require('../assets/alipay-ok.png'),
      payInfo:{
        deveiceNo:'',
        businessNo:'',
        payType:'',
        paySn:'',
        payMoney:'',
      },
    }
  },
  mounted () {
    document.title="支付完成"
    //是否是微信环境
    var ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //在微信里
        this.radio = '1'

      }else if(ua.match(/AlipayClient/i) == "alipayclient"){
        //在支付宝里
        this.radio = '2'

      }
    
    this.getData()
  },
  methods: {
    // 获取地址栏参数
    getQueryVariable (variable) {
    var query = window.location.href;
 //   var query = 'http://www.dkjtapp.com/#/order?payNo=15'  //生成二维码的链接
      var querys = query.split('?')
      var pair = querys[1].split('=')
      if (pair[0] === variable) { return pair[1] };
      return (false)
    },
    getData(){
      this.payInfo.deveiceNo = localStorage.getItem("deveiceNo")
      this.payInfo.businessNo = localStorage.getItem("businessNo")
      this.payInfo.payType = localStorage.getItem("payType")
      this.payInfo.payMoney = localStorage.getItem("payMoney")
      this.payOK()
      //日期
      var now = new Date();
      var year = now.getFullYear();//得到年份
      var month = now.getMonth() + 1;//得到月份
      var date = now.getDate();//得到日期
      var hour = now.getHours();//得到小时
      var minu = now.getMinutes();//得到分钟

      // console.log("month",month)
    this.time = year + "年" + month + "月" + date + "日" + " " + this.PrefixInteger(hour,2) + ":" +  this.PrefixInteger(minu,2)
    },
    //补足位数
    PrefixInteger(num, length) {
      return (Array(length).join('0') + num).slice(-length);
    },
    payOK(){
      this.payInfo.paySn = this.getQueryVariable('payNo')
      if(this.payInfo.paySn){
        // get('/queryPayFee.do',this.payInfo).then(res=>{
        // console.log("支付完成提示",res);
        // if(res.retCode == '0'){
        
        // }
        // }).catch(err=>{
        // })
      }else{
        // 支付失败去首页
         window.location.href = 'http://www.dkjtapp.com/?deveiceNo=' + this.payInfo.deveiceNo
      }
      
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page{
  /* height: 100vh; */
  background: #fff;
}
.top{
  width: 100%;
  margin: 10px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* background: red; */
}
.order-ok{
  width: 60px;
  height: 60px;
  /* background: red; */

}
.order-ok img{
  width:60px;
  height: 60px;
}
.tips{
  color: #666;
  font-size: 20px;
  margin-top: 10px;
}
.money{
  color: #1F1A17;
  font-size: 22px;
  /* margin-top: 10px; */

}
.money2{
  color: #969594;
  font-size: 19px;
}
.plate{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  /* background: #F9F9F9; */
  margin-top: 3px;
}
.plate-left{
  display: flex;
  flex-direction: row;
  font-size: 17px;
  color: #969594;
  font-weight: 500;
}
.righ-class{
  color: #1F1A17;
  font-size: 17px;
}
.collection-info{
  margin-top: 20px;
  border-bottom: 1px solid #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/order.vue